<template>
  <div>
    <h3 class="primary--text">{{ question }}</h3>
    <br>
    <v-row
      justify="center"
    >
      <v-col
        class="no-padding"
        cols="12"
        sm="6"
        v-for="choice in choicesObj"
        :key="`col${choice.index}`"
      >
        <Choice
          :key="`choice${choice.index}`"
          :item="choice"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import lazyLoad from '@/utils/lazyLoad';
import get from 'lodash.get';

export default {
  name: 'PathDependent',
  components: {
    Choice: lazyLoad('components/Cards/Choice/Index'),
  },
  computed: {
    ...mapGetters('testMicro', [
      'activeStep',
      'step',
      'selected',
      'selectedIndex',
      'choiceJourney',
      'formSteps',
    ]),
    question() {
      const { question } = this.step;
      return this.getItem(question);
    },
    choices() {
      const { choices } = this.step;
      return this.getItem(choices);
    },
    overlaysPreSelect() {
      const { length } = Object.keys(this.choices);
      return Array(length).fill(false);
    },
    overlaysPostSelect() {
      const overlays = Array.from(this.overlaysPreSelect);
      overlays.splice(this.selectedIndex, 1, true);
      const invOverlays = overlays.map((bool) => (!bool));
      return invOverlays;
    },
    choicesObj() {
      const keys = Object.keys(this.choices);
      const overlays = this.selected ? this.overlaysPostSelect : this.overlaysPreSelect;
      const result = keys.map((index) => ({
        index,
        text: this.choices[index],
        overlay: overlays[index],
      }));
      return result;
    },
    lastChoices() {
      const obj = get(this.formSteps, '3.choices.0.0.0');
      return Object.values(obj);
    },
    lastStep() {
      return !!this.lastChoices.every((r) => Object.values(this.choices).includes(r));
    },
  },
  watch: {
    choices() {
      if (this.lastStep) {
        const length = this.activeStep + 1;
        this.setLength(length);
      }
    },
  },
  methods: {
    ...mapActions('testMicro', [
      'setLength',
    ]),
    getItem(item) {
      return this.activeStep === 0 ? item : get(item, this.choiceJourney);
    },
  },
};
</script>
